import { render, staticRenderFns } from "./ButtonInput.vue?vue&type=template&id=07f50521&scoped=true&"
import script from "./ButtonInput.vue?vue&type=script&lang=ts&"
export * from "./ButtonInput.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonInput.vue?vue&type=style&index=0&id=07f50521&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f50521",
  null
  
)

export default component.exports